'use client';

import Typography from '@mui/material/Typography';
import { StockAvailabilityType } from '@/utils/helpers/stock';

export type StockAvailabilityStatus = {
	key: StockAvailabilityType;
	label: string;
} | null;

export interface StockAvailabilityProps {
	availability: StockAvailabilityStatus;
}

export default function StockAvailability({ availability }: Readonly<StockAvailabilityProps>) {
	if (!availability) return null;

	const { key, label } = availability;

	const getColor = () => {
		switch (key) {
			case StockAvailabilityType.BUILD_TO_ORDER:
				return 'orange.main';
			case StockAvailabilityType.IN_STOCK:
				return 'green.main';
			case StockAvailabilityType.OUT_OF_STOCK:
				return 'red.main';
			default:
				return 'grey.500';
		}
	};

	return (
		<Typography variant="title" color={getColor()} data-testid="stock-availability">
			{label}
		</Typography>
	);
}
